"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNode = exports.isNodeConfig = exports.hasArtifactType = exports.typeGuard = exports.artifactType = exports.cloneFromTemplateArtifact = void 0;
const typeguards_1 = require("../typeguards");
const node_1 = require("./node");
Object.defineProperty(exports, "artifactType", { enumerable: true, get: function () { return node_1.artifactType; } });
var clone_1 = require("./clone");
Object.defineProperty(exports, "cloneFromTemplateArtifact", { enumerable: true, get: function () { return clone_1.cloneFromTemplateArtifact; } });
const { isNodeConfig, typeGuard, hasArtifactType } = (0, typeguards_1.createZodTypeGuards)(node_1.NodeConfigSchema, node_1.NodeTypeSchema, node_1.artifactType);
exports.isNodeConfig = isNodeConfig;
exports.typeGuard = typeGuard;
exports.hasArtifactType = hasArtifactType;
/** @deprecated Use hasArtifactType. */
exports.isNode = hasArtifactType;
//# sourceMappingURL=index.js.map